import {getAbsoluteUrl} from "../../utils/urlUtill";
import {IHttpService, IPromise, IQService} from "angular";
import {ImageResponse} from "../model/ImageModel";
import {globalFetch} from "../../../initializers/ActiveBrandInitializer";

export class S3File {
    id?: number;
    url: string;
    fileName?: string;
}

export class ImageService {

    static instance = ['$http', '$q', ImageService];

    constructor(private $http: IHttpService,
                private $q: IQService) {
    }


    public uploadImage = (formData): IPromise<ImageResponse> => {
        return this.$q.when(
            globalFetch(
                getAbsoluteUrl('api/image'),
                'POST',
                formData
            )
        );
    };

    public static getInputFormData(fileInputId: string) {
        let fileInput = <HTMLInputElement>document.getElementById(fileInputId);
        let file = fileInput.files[0];
        let formData = new FormData();
        formData.append('file', file);
        return formData;
    }
}